import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NonProductionRouteGuardService, AuthGuard, MaintenanceGuardService } from './core/services';
import { OptionalFeatureRouteGuardService } from './core/services/guards';
import { UnAuthGuard } from './core/services/guards/un-auth-guard.service';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
    canActivate: [MaintenanceGuardService, OptionalFeatureRouteGuardService, UnAuthGuard],
  },
  {
    path: 'agents',
    loadChildren: () => import('./agents/agents.module').then((m) => m.AgentsModule),
    canActivate: [MaintenanceGuardService, OptionalFeatureRouteGuardService],
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./maintenance/maintenance.module').then((m) => m.MaintenanceModule),
    canActivate: [MaintenanceGuardService, OptionalFeatureRouteGuardService],
    data: { isPublicRoute: true },
  },
  {
    path: 'style-guide',
    loadChildren: () => import('./style-guide/style-guide.module').then((m) => m.StyleGuideModule),
    canActivate: [NonProductionRouteGuardService],
    data: { isPublicRoute: true },
  },
  {
    path: 'test-patients',
    loadChildren: () => import('./test-patients/test-patients.module').then((m) => m.TestPatientsModule),
    canActivate: [NonProductionRouteGuardService],
    data: { isPublicRoute: true },
  },
  {
    path: '',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    canActivate: [MaintenanceGuardService, AuthGuard, OptionalFeatureRouteGuardService],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
